module.exports = __webpack_public_path__ + "lk.d5cf9401.svg";